<template>
  <button :class="[baseClass, variantClass, $attrs.class]" v-bind="$attrs" @click="$emit('click', $event)">
    <span v-if="$slots.icon" class="mr-2 flex items-center">
      <slot name="icon" />
    </span>
    <span><slot /></span>
  </button>
</template>

<script>
export default {
  props: {
    variant: { type: String, default: "default" }
  },
  computed: {
    baseClass() {
      return "group flex h-11 items-center justify-center gap-2 rounded-xl px-5 font-medium shadow-sm transition-all duration-200";
    },
    variantClass() {
      switch (this.variant) {
        case "primary":
          return "bg-blue-500 text-white hover:bg-blue-600";
        case "ghost":
          return "border border-gray-200 bg-white text-gray-700 hover:bg-gray-50 hover:border-gray-300";
        default:
          return "border border-gray-200 bg-white text-gray-700 hover:bg-gray-50";
      }
    }
  }
};
</script>

<style scoped></style>
